/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import RoleDto from './RoleDto';

/**
 * The PaginatedRolesDto model module.
 * @module model/PaginatedRolesDto
 * @version v0
 */
class PaginatedRolesDto {
    /**
     * Constructs a new <code>PaginatedRolesDto</code>.
     * @alias module:model/PaginatedRolesDto
     */
    constructor() { 
        
        PaginatedRolesDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>PaginatedRolesDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/PaginatedRolesDto} obj Optional instance to populate.
     * @return {module:model/PaginatedRolesDto} The populated <code>PaginatedRolesDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new PaginatedRolesDto();

            if (data.hasOwnProperty('page')) {
                obj['page'] = ApiClient.convertToType(data['page'], 'Number');
            }
            if (data.hasOwnProperty('limit')) {
                obj['limit'] = ApiClient.convertToType(data['limit'], 'Number');
            }
            if (data.hasOwnProperty('totalPages')) {
                obj['totalPages'] = ApiClient.convertToType(data['totalPages'], 'Number');
            }
            if (data.hasOwnProperty('totalElements')) {
                obj['totalElements'] = ApiClient.convertToType(data['totalElements'], 'Number');
            }
            if (data.hasOwnProperty('roles')) {
                obj['roles'] = ApiClient.convertToType(data['roles'], [RoleDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>PaginatedRolesDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>PaginatedRolesDto</code>.
     */
    static validateJSON(data) {
        if (data['roles']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['roles'])) {
                throw new Error("Expected the field `roles` to be an array in the JSON data but got " + data['roles']);
            }
            // validate the optional field `roles` (array)
            for (const item of data['roles']) {
                RoleDto.validateJSON(item);
            };
        }

        return true;
    }


}



/**
 * @member {Number} page
 */
PaginatedRolesDto.prototype['page'] = undefined;

/**
 * @member {Number} limit
 */
PaginatedRolesDto.prototype['limit'] = undefined;

/**
 * @member {Number} totalPages
 */
PaginatedRolesDto.prototype['totalPages'] = undefined;

/**
 * @member {Number} totalElements
 */
PaginatedRolesDto.prototype['totalElements'] = undefined;

/**
 * @member {Array.<module:model/RoleDto>} roles
 */
PaginatedRolesDto.prototype['roles'] = undefined;






export default PaginatedRolesDto;

